import * as React from 'react'
import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

type SplashTitleProps = React.HtmlHTMLAttributes<HTMLDivElement> & {
  text: string
}

function SplashTitleComponent(props: SplashTitleProps): React.ReactElement<SplashTitleProps> {
  return (
    <plume.styles.heading.XXS asDesktop="S" {...props}>
      {props.text}
    </plume.styles.heading.XXS>
  )
}

export const SplashTitle = styled(SplashTitleComponent)`
  background-color: ${plume.COLORS.PRIMARY_BLUE_900};
  color: ${plume.COLORS.PRIMARY_GREY_000};
  display: inline-block;
  font-weight: 700; // HACK: Irregular font manipulation
  line-height: 1.5;
  padding: 0px 10px;
  transform: rotate(-4deg);
`
